import React from 'react';

const Divider = () => <div className="Divider" />;

export default Divider;



// WEBPACK FOOTER //
// ./src/components/Divider.js